require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./member-gerard-siasat.json") })
        }
      }, "path---member-gerard-siasat");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---member-gerard-siasat!./.cache/json/member-gerard-siasat.json
// module id = 398
// module chunks = 231608221292675